/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES API 【企業詳細】
 * PR TIMESの企業詳細画面用のAPI
 *
 * The version of the OpenAPI document: 1.5.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface YahooProofResponseResultData
 */
export interface YahooProofResponseResultData {
    /**
     * 校正対象文字列; 機種依存文字または拡張文字の時、空文字
     * @type {string}
     * @memberof YahooProofResponseResultData
     */
    word: string;
    /**
     * 校正内容
     * @type {string}
     * @memberof YahooProofResponseResultData
     */
    rule: YahooProofResponseResultDataRuleEnum;
    /**
     * 推奨例; 無い場合は空文字
     * @type {string}
     * @memberof YahooProofResponseResultData
     */
    suggestion: string;
    /**
     * 対象文字列の、元の文章内での開始位置
     * @type {string}
     * @memberof YahooProofResponseResultData
     */
    offset: string;
    /**
     * 校正についての補足
     * @type {string}
     * @memberof YahooProofResponseResultData
     */
    note: string;
}

/**
* @export
* @enum {string}
*/
export enum YahooProofResponseResultDataRuleEnum {
    MACHINE_DEPENDENT_OR_ESCAPE = '機種依存または拡張文字',
    MISSING_RA = 'ら抜き',
    UNCONFORTABLE = '不快語',
    WRONG_KANJI = '誤変換',
    HANDLE_WITH_CARE = '使用注意',
    DOUBLE_NEGATIVE = '二重否定'
}

export function YahooProofResponseResultDataFromJSON(json: any): YahooProofResponseResultData {
    return YahooProofResponseResultDataFromJSONTyped(json, false);
}

export function YahooProofResponseResultDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): YahooProofResponseResultData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'word': json['word'],
        'rule': json['rule'],
        'suggestion': json['suggestion'],
        'offset': json['offset'],
        'note': json['note'],
    };
}

export function YahooProofResponseResultDataToJSON(value?: YahooProofResponseResultData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'word': value.word,
        'rule': value.rule,
        'suggestion': value.suggestion,
        'offset': value.offset,
        'note': value.note,
    };
}

